export const VECTOR_ELEMENTS = [
  "Teebox",
  "Fairway",
  "Green",
  "Bunker",
  "Tree",
  "Water",
  "Perimeter",
  "Centralpath",
  "Cartpath",
  "Outofbounds",
];

export const HOLE_VECTOR_ELEMENTS = [
  "Teebox",
  "Fairway",
  "Green",
  "Bunker",
  "Perimeter",
  "Apron",
  "Centralpath",
];

export const isVectorElement = (el) => {
  return [
    "Teebox",
    "Fairway",
    "Green",
    "Bunker",
    "Tree",
    "Water",
    "Perimeter",
    "Centralpath",
    "Cartpath",
    "Outofbounds",
  ].includes(el);
};

export const isHoleVectorElement = (name) => HOLE_VECTOR_ELEMENTS.includes(name)

export const elementToApiName = (el) => el;